import ArticleCard from '@/components/base/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import type { Article } from '@/mocks/articles';

interface RelatedArticlesProps {
  articles: Article[];
}

export default function RelatedArticles({ articles }: RelatedArticlesProps) {
  if (articles.length === 0) return null;

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-16">
        <SectionHeading eyebrow="继续阅读" title="与这篇观察相关的条目" />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}